/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 *
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date          Author        Remarks
 * 1.0.0    23 Jun 2021   Tuan Le       Bug 44454 - [Bronner] [SBOX] Retail Site - Pass form data to Evergage
 */

// Model.js
// -----------------------
// @module Case
define("BTM.EvergageFormData.EvergageFormData.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({


        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/EvergageFormData.Service.ss"
            )
        )

});
});
